import type { Week } from 'ember-power-calendar/-private/days-utils';
import type { CalendarAPI } from 'ember-power-calendar/components/power-calendar';
import { emberPowerCalendarDayClasses } from 'ember-power-calendar/helpers/ember-power-calendar-day-classes';
import type { PowerCalendarDay } from 'ember-power-calendar/utils';

type Day = PowerCalendarDay & {
  isDayInHoveredRange?: boolean;
};

export default function emberPowerCalendarDayClassesCustom(
  day: Day,
  calendar: CalendarAPI,
  weeks: Week[],
  dayClass?: string,
): string {
  let classNames = emberPowerCalendarDayClasses([
    day,
    calendar,
    weeks,
    // @ts-expect-error: Incorrect type
    dayClass,
  ]);

  if (day.isDayInHoveredRange) {
    classNames += ' ember-power-calendar-day--selected';
  }

  return classNames;
}
